import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import axios from 'axios';
import { toast } from 'react-toastify';
import { ServerPath } from '../../Constant';

const EditAd = ({ show, onHide, adData }) => {
    const [formData, setFormData] = useState({
        android_adv_id: '',
        ios_adv_id: '',
        location: '',
        ad_type: '',
        status: ''
    });

    const [isLoading, setIsLoading] = useState(false);

    // Initialize form data when component receives adData
    useEffect(() => {
        if (adData) {
            setFormData({
                android_adv_id: adData.android_adv_id || '',
                ios_adv_id: adData.ios_adv_id || '',
                location: adData.location || '',
                ad_type: adData.ad_type || '',
                status: adData.status || 'New'
            });
        }
    }, [adData]);

    // Handle form field changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Validate required fields
        if ((!formData.android_adv_id && !formData.ios_adv_id) || !formData.location || !formData.ad_type) {
            toast.error('Please fill in all required fields');
            return;
        }

        try {
            setIsLoading(true);
            
            // Prepare data for API
            const updateData = {
                android_adv_id: formData.android_adv_id,
                ios_adv_id: formData.ios_adv_id,
                location: formData.location,
                ad_type: formData.ad_type,
                status: formData.status
            };
            
            // Call API to update ad
            const response = await axios.put(`${ServerPath}/advertisements/update/${adData.id}`, updateData);
            
            if (response.data.success) {
                toast.success('Advertisement updated successfully');
                onHide(); // Close modal after successful update
            } else {
                toast.error(response.data.message || 'Failed to update advertisement');
            }
        } catch (error) {
            console.error('Error updating advertisement:', error);
            toast.error(error.response?.data?.message || 'Failed to update advertisement');
        } finally {
            setIsLoading(false);
        }
    };

    // Location options
    const locationOptions = ['Madhya Pradesh', 'Gujarat', 'Maharashtra', 'All'];
    
    // Ad type options
    const adTypeOptions = ['Banner Ads', 'Interstitial Ads', 'Rewarded Interstitial Ads'];

    return (
        <Modal show={show} onHide={onHide} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Edit Ads</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <Row className="mb-3">
                        <Col md={4}>
                            <div className="mb-3">
                                <Form.Label>Adv. ID</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={adData?.ad_id || ''}
                                    disabled
                                    className="bg-light"
                                />
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="mb-3">
                                <Form.Label>Created On</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={adData?.created_date || ''}
                                    disabled
                                    className="bg-light"
                                />
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="mb-3">
                                <Form.Label>Last Update On</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={adData?.last_updated_date || ''}
                                    disabled
                                    className="bg-light"
                                />
                            </div>
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Col md={6}>
                            <div className="mb-3">
                                <Form.Label>Android Adv ID</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="android_adv_id"
                                    value={formData.android_adv_id}
                                    onChange={handleChange}
                                    placeholder="Enter Android Advertisement ID"
                                />
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="mb-3">
                                <Form.Label>iOS Adv ID</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="ios_adv_id"
                                    value={formData.ios_adv_id}
                                    onChange={handleChange}
                                    placeholder="Enter iOS Advertisement ID"
                                />
                            </div>
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Col md={6}>
                            <div className="mb-3">
                                <Form.Label>Ad Type</Form.Label>
                                <Form.Select
                                    name="ad_type"
                                    value={formData.ad_type}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">Select Ad Type</option>
                                    {adTypeOptions.map((type, index) => (
                                        <option key={index} value={type}>
                                            {type}
                                        </option>
                                    ))}
                                </Form.Select>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="mb-3">
                                <Form.Label>Location</Form.Label>
                                <Form.Select
                                    name="location"
                                    value={formData.location}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">Select Location</option>
                                    {locationOptions.map((location, index) => (
                                        <option key={index} value={location}>
                                            {location}
                                        </option>
                                    ))}
                                </Form.Select>
                            </div>
                        </Col>
                    </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer className="justify-content-end">
                <Button 
                    variant="primary" 
                    onClick={handleSubmit} 
                    disabled={isLoading}
                    className="px-4"
                >
                    {isLoading ? 'Updating...' : 'Update'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EditAd;